import Model from "./abstract/Model";
import Address from "./Address";

export default class Company extends Model {
    constructor(props) {
      super();

      this.initializeAttributes(props, {
        'address': Address
      });
    }
}
